module.exports = __webpack_public_path__ + "news_title.ccd179d4.png";